import { useMemo } from 'react';
import { isLocalhost, DomainKey, DEFAULT_DOMAIN } from '../config/domains';

interface ClientDomainResult {
  domain: DomainKey;
  isLocalDevelopment: boolean;
}

/**
 * Hook to detect the current domain hostname
 *
 * In development (localhost), you can override the domain by setting:
 * localStorage.setItem('dev-domain', 'onboarding.nxt-travel.com')
 *
 * @returns Domain hostname and development flag
 */
export function useClientDomain(): ClientDomainResult {
  const domainData = useMemo(() => {
    const hostname = window.location.hostname;
    const isLocal = isLocalhost(hostname);

    let effectiveHostname = hostname;

    if (isLocal && typeof window !== 'undefined') {
      const devDomain = localStorage.getItem('dev-domain');
      if (devDomain) {
        effectiveHostname = devDomain;
        console.log(`[Dev Mode] Using domain override: ${devDomain}`);
      } else {
        effectiveHostname = DEFAULT_DOMAIN;
      }
    }

    return {
      domain: effectiveHostname,
      isLocalDevelopment: isLocal,
    };
  }, []);

  return domainData;
}
